import type { Theme, ThemeToken } from '@ui';
import { createContext, use } from 'react';

type ThemeContextType = {
    token: Record<ThemeToken, string>;
    theme: Theme;
    setTheme: (theme: Theme) => void;
};

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const useTheme = () => {
    const context = use(ThemeContext);

    if (!context)
        throw new Error('Your app must be wrapped in ThemeProvider');

    return context;
};
